
import { motion } from "framer-motion";
import { Loader } from "lucide-react";

export const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white">
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Loader className="w-16 h-16 text-[#0073B7] animate-spin" />
      </motion.div>
    </div>
  );
};
